import toast from "react-hot-toast";
import { all, takeLatest, put, call, select, delay, take, race, fork } from "redux-saga/effects";
import { selectIdToken, unauthorized } from "../../../auth/redux/slice";
import { selectConfig } from "../../../shared/redux/slice";
import { IConfiguration } from "../../../shared/types";
import { AxiosResponse } from "axios";
import { SimplyTestApi } from "../../../api/simplytest";
import userGroupsAddEditSlice, { createUserGroup, loadUserGroup, updateUserGroup } from "./slice";
import { CreateUserGroupRequest, UpdateUserGroupRequest, UserGroup } from "../../../api/types";
import { parsePath } from "react-router-dom";
import { ROUTES } from "../../../shared/constants";

export abstract class UserGroupsAddEditSagas {
    public static* run() {
        try {
            yield all([
                takeLatest(loadUserGroup, UserGroupsAddEditSagas.loadUserGroup),
                takeLatest(createUserGroup, UserGroupsAddEditSagas.createUserGroup),
                takeLatest(updateUserGroup, UserGroupsAddEditSagas.updateUserGroup),
            ]);
        }
        catch(e: any){
            toast.error('Unable to register UserGroupsAddEdit module.');
            console.log(`[UserGroupsAddEdit:run] the following exception has occurred`, e);
        }
    }

    public static* loadUserGroup(action: ReturnType<typeof loadUserGroup>) {
        try {
            const { payload: id } = action;
            yield put(userGroupsAddEditSlice.actions.setState('BUSY'));
            const config: IConfiguration = yield select(selectConfig);
            const idToken: string = yield select(selectIdToken);
            
            var client = new SimplyTestApi(config.apiBaseUrl, idToken);
            const userGroupResponse: AxiosResponse<UserGroup> = yield call(
                {
                    context: client,
                    fn: client.getUserGroup,
                },
                id
            );

            if(userGroupResponse.status === 401)
            {
                yield put(unauthorized(undefined));
                return;     
            }
            
            if(userGroupResponse.status !== 200)
                throw new Error("Error communicating with Api");

            const { data: userGroup } = userGroupResponse;
            yield put(userGroupsAddEditSlice.actions.setUserGroup(userGroup));
            yield put(userGroupsAddEditSlice.actions.setState('READY'));
        }
        catch(e: any){
            toast.error('Unable to load price group.');
            console.log(`[UserGroupsAddEditSagas:loadUserGroup] the following exception has occurred`, e);
        }
    }

    public static* createUserGroup(action: ReturnType<typeof createUserGroup>) {
        try {
            const { payload: { navigate, ...req } } = action;
            yield put(userGroupsAddEditSlice.actions.setState('BUSY'));
            const config: IConfiguration = yield select(selectConfig);
            const idToken: string = yield select(selectIdToken);
            
            var client = new SimplyTestApi(config.apiBaseUrl, idToken);
            const createUserGroupResponse: AxiosResponse<UserGroup> = yield call(
                {
                    context: client,
                    fn: client.createUserGroup,
                },
                req as CreateUserGroupRequest
            );

            if(createUserGroupResponse.status === 401)
            {
                yield put(unauthorized(undefined));
                return;     
            }
            
            if(createUserGroupResponse.status !== 200)
                throw new Error("Error communicating with Api");

            yield put(userGroupsAddEditSlice.actions.setState('READY'));
            
            navigate(parsePath(ROUTES.UserGroups));
        }
        catch(e: any){
            toast.error('Unable to create price group.');
            console.log(`[UserGroupsAddEditSagas:createUserGroup] the following exception has occurred`, e);
        }
    }

    public static* updateUserGroup(action: ReturnType<typeof updateUserGroup>) {
        try {
            const { payload: { navigate, userGroupId, ...req } } = action;
            yield put(userGroupsAddEditSlice.actions.setState('BUSY'));
            const config: IConfiguration = yield select(selectConfig);
            const idToken: string = yield select(selectIdToken);
            
            var client = new SimplyTestApi(config.apiBaseUrl, idToken);
            const updateUserGroupResponse: AxiosResponse<UserGroup> = yield call(
                {
                    context: client,
                    fn: client.updateUserGroup,
                },
                userGroupId,
                req as UpdateUserGroupRequest
            );

            if(updateUserGroupResponse.status === 401)
            {
                yield put(unauthorized(undefined));
                return;     
            }
            
            if(updateUserGroupResponse.status !== 200)
                throw new Error("Error communicating with Api");

            yield put(userGroupsAddEditSlice.actions.setState('READY'));
            
            navigate(parsePath(ROUTES.UserGroups));
        }
        catch(e: any){
            toast.error('Unable to update price group.');
            console.log(`[UserGroupsAddEditSagas:updateUserGroup] the following exception has occurred`, e);
        }
    }
}